export default __webpack_public_path__ + "static/media/pentester.03c4debc.png";